/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component, Input, ViewChild } from "@angular/core";

import { NzOptionContainerComponent } from "ng-zorro-antd/select";
import { UiSelectItemInterface, UiSelectModeType } from "@webapp/ui/select/select.models";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";

@Component({
  selector: "ui-option-container",
  exportAs: "uiOptionContainer",
  templateUrl: "option-container.component.html",
})
export class UiOptionContainerComponent extends NzOptionContainerComponent {
  @Input() mode: UiSelectModeType = "default";
  @Input() listOfContainerItem: UiSelectItemInterface[] = [];
  @ViewChild(CdkVirtualScrollViewport, { static: true }) cdkVirtualScrollViewport!: CdkVirtualScrollViewport;
}
